module.exports = __webpack_public_path__ + "73500b4fff99c2e820871c8f74ecd8fe.gif";